import { useContext } from 'react';
import { AppContext } from '../App';
import { useI18n } from '../i18n/index.jsx';
import api from '../api';

/**
 * Tier Selection — first screen of onboarding.
 * 
 * Tier 1: Бизнес Инкубатор — work through our company (NOTO RECRUT)
 * Tier 2: Своя фирма — bring your own company, full accounting
 */

export default function TierSelect() {
  const { setPage } = useContext(AppContext);
  const { t } = useI18n();

  async function handleSelect(tier) {
    try {
      await api.post('/onboarding/select-tier', { tier });
    } catch (e) {
      console.error('Failed to save tier:', e);
    }

    if (tier === 'incubator') {
      setPage('client_onboarding');
    } else {
      setPage('own_company_onboarding');
    }
  }

  return (
    <div className="onboarding-flow">
      <div className="onboarding-step">
        <div className="model-icon">🚀</div>
        <h1>{t('tier_select.title')}</h1>
        <p className="model-desc">{t('tier_select.subtitle')}</p>

        <div className="type-cards" style={{ marginTop: 24 }}>
          {/* Tier 1: Business Incubator */}
          <div
            className="type-card"
            onClick={() => handleSelect('incubator')}
            style={{ cursor: 'pointer' }}
          >
            <div className="type-icon">🏢</div>
            <h3>{t('tier_select.incubator_title')}</h3>
            <p style={{ fontSize: 13, opacity: 0.85 }}>
              {t('tier_select.incubator_desc')}
            </p>
            <ul style={{ textAlign: 'left', fontSize: 13, marginTop: 12 }}>
              <li>✓ {t('tier_select.incubator_f1')}</li>
              <li>✓ {t('tier_select.incubator_f2')}</li>
              <li>✓ {t('tier_select.incubator_f3')}</li>
              <li>✓ {t('tier_select.incubator_f4')}</li>
            </ul>
            <div style={{
              marginTop: 12, padding: '8px 16px',
              background: 'rgba(99,102,241,0.2)', borderRadius: 8,
              fontSize: 14, fontWeight: 700, color: '#818cf8'
            }}>
              {t('tier_select.incubator_price')}
            </div>
          </div>

          {/* Tier 2: Own Company */}
          <div
            className="type-card"
            onClick={() => handleSelect('own_company')}
            style={{ cursor: 'pointer' }}
          >
            <div className="type-icon">🏗️</div>
            <h3>{t('tier_select.own_title')}</h3>
            <p style={{ fontSize: 13, opacity: 0.85 }}>
              {t('tier_select.own_desc')}
            </p>
            <ul style={{ textAlign: 'left', fontSize: 13, marginTop: 12 }}>
              <li>✓ {t('tier_select.own_f1')}</li>
              <li>✓ {t('tier_select.own_f2')}</li>
              <li>✓ {t('tier_select.own_f3')}</li>
              <li>✓ {t('tier_select.own_f4')}</li>
              <li>✓ {t('tier_select.own_f5')}</li>
            </ul>
            <div style={{
              marginTop: 12, padding: '8px 16px',
              background: 'rgba(16,185,129,0.2)', borderRadius: 8,
              fontSize: 14, fontWeight: 700, color: '#10b981'
            }}>
              {t('tier_select.own_price')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
